/* tslint:disable */

declare var Object: any;
export interface UIDiagnosticInterface {
  "id"?: number;
}

export class UIDiagnostic implements UIDiagnosticInterface {
  "id": number;
  constructor(data?: UIDiagnosticInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `UIDiagnostic`.
   */
  public static getModelName() {
    return "UIDiagnostic";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of UIDiagnostic for dynamic purposes.
  **/
  public static factory(data: UIDiagnosticInterface): UIDiagnostic{
    return new UIDiagnostic(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'UIDiagnostic',
      plural: 'UIDiagnostics',
      path: 'UIDiagnostics',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}
